import React from 'react';

const Partners = () => {
  const partners = [
    {
      name: 'All Ways of Caring',
      description: 'Home Care Services',
      logo: 'https://via.placeholder.com/200x80/008B8B/FFFFFF?text=All+Ways+of+Caring'
    },
    {
      name: 'Pharmacy Partner',
      description: 'Advanced Medication Management',
      logo: 'https://via.placeholder.com/200x80/008B8B/FFFFFF?text=Pharmacy+Partner'
    },
    {
      name: 'NP Offices',
      description: 'Nurse Practitioner Services',
      logo: 'https://via.placeholder.com/200x80/008B8B/FFFFFF?text=NP+Offices'
    },
    {
      name: 'Operating Partners',
      description: 'Licensed Care Facilities',
      logo: 'https://via.placeholder.com/200x80/008B8B/FFFFFF?text=Operating+Partners'
    }
  ];

  return (
    <section id="partners" className="partners">
      <div className="container">
        <div className="section-header">
          <h2>Our Trusted Partners</h2>
          <p>Working together to provide comprehensive care and support</p>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-card">
              <div className="partner-logo">
                <img src={partner.logo} alt={partner.name} />
              </div>
              <div className="partner-info">
                <h3>{partner.name}</h3>
                <p>{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;